import React from 'react';
import ActiveClientsTile from "../../../../../components/customBreachBits/metrics/ActiveClientsTile";
import TileCountCIRTActive from "../../../../../components/customBreachBits/metrics/TileCountCIRTActive";
import TileCountActiveUsers from "../../../../../components/customBreachBits/metrics/TileCountActiveUsers";
import {Col, Row} from "reactstrap";
import NewClientsTable from "../../../../../components/customBreachBits/admin/AdminDashInfo/TableAdminDashNewClientsInfo";
import NewUsersTable
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TableAdminDashNewUsersInfo";
import TileNewClients
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TileAdminDashNewClients";
import TileNewUsers
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TileAdminDashNewUsers";
import TileAverageLoginsPaidCustomers
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TileAverageLoginsPaidCustomers";
import AdminDashCustomerTypeChart
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/AdminDashCustomerTypeChart";
import TileAdminDashPaidCustomerPieChart
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TileAdminDashPaidCustomerPieChart";


const Dashboard= (props) => {

    return (
        <div className="animated fadeIn animation-duration-7">
            <div  className="app-wrapper h-100">
                <Row>
                    <Col key={"newUsersTile"} >
                        <TileNewUsers />
                    </Col>

                    <Col key={"activeUsersTile"}  >
                        <TileCountActiveUsers/>
                    </Col>
                    <Col>

                        <TileAverageLoginsPaidCustomers/>
                    </Col>

                    <Col key={"newClientsTile"} >
                        <TileNewClients/>
                    </Col>
                    <Col key={"activeClientsTile"} >
                        <ActiveClientsTile />
                    </Col>

                </Row>

                <Row>
                    <Col>
                        <TileAdminDashPaidCustomerPieChart/>
                    </Col>
                    <Col>
                        <AdminDashCustomerTypeChart/>
                    </Col>
                </Row>

                <Row>

                    <Col key={"newClientsTable"}>
                        <NewClientsTable />
                    </Col>

                    <Col key={"newUsersTable"}  >
                        <NewUsersTable />
                    </Col>

                </Row>


                <Row style={{display: 'flex', alignItems:`center`, }}>
                    <Col  key={"anotherDataTile"}  xl="3" l="3" md="4" sm="6">
                        <TileCountCIRTActive/>
                    </Col>
                    <Col xl="9" l="9" md="8" sm="12">

                    </Col>
                </Row>
            </div>
        </div>
    )

}

export default Dashboard;